"use client";

import { useState, useRef } from "react";
import { IconButton } from "@mui/material";
import { Swiper, SwiperSlide } from "swiper/react";
import Image from "next/image";

import "swiper/css";

import styles from "./ChatContent.module.scss";

interface ChatContentProps {
  onInputFocus?: () => void;
  onInputBlur?: () => void;
  className?: string;
  isChatCompact?: boolean;
}

const chatSuggestions = [
  "What amenities does Flow Miami offer?",
  "Are there any studios available for July?",
  "What are the lease terms?",
  "Is parking included?",
  "Are pets allowed?",
  "What is the application process?",
  "How much is the security deposit?",
  "When can I schedule a tour?",
];

function ChatContent({ onInputFocus, onInputBlur, className, isChatCompact }: ChatContentProps) {
  const [inputValue, setInputValue] = useState("");
  const inputRef = useRef<HTMLInputElement>(null);

  const handleSuggestionClick = (suggestion: string) => {
    setInputValue(suggestion);
    inputRef.current?.focus();
  };

  const handleInputFocus = () => {
    onInputFocus?.();
  };

  const handleInputBlur = () => {
    onInputBlur?.();
  };

  const handleSubmit = () => {
    if (inputValue.trim()) {
      setInputValue("");
    }
  };

  const handleKeyPress = (e: React.KeyboardEvent) => {
    if (e.key === "Enter") {
      handleSubmit();
    }
  };

  return (
    <div className={`${styles.chatContent} ${className || ""}`}>
      {!isChatCompact && <div className={styles.messagesArea}>{/* Placeholder for chat messages */}</div>}
      <div className={styles.chatContentContainer}>
        <div className={styles.suggestionsContainer}>
          <Swiper
            spaceBetween={12}
            slidesPerView="auto"
            className={styles.suggestionCarousel}
          >
            {chatSuggestions.map((suggestion, index) => (
              <SwiperSlide
                key={index}
                className={styles.suggestionSlide}
              >
                <div
                  className={styles.suggestionBox}
                  onClick={() => handleSuggestionClick(suggestion)}
                >
                  {suggestion}
                </div>
              </SwiperSlide>
            ))}
          </Swiper>
        </div>
        <div className={styles.inputContainer}>
          <input
            ref={inputRef}
            type="text"
            value={inputValue}
            onChange={(e) => setInputValue(e.target.value)}
            onFocus={handleInputFocus}
            onBlur={handleInputBlur}
            onKeyDown={handleKeyPress}
            placeholder="Type your message..."
            className={styles.inputField}
          />
          <IconButton
            onClick={handleSubmit}
            className={styles.submitButton}
            disabled={!inputValue.trim()}
          >
            <Image
              src="/image/icon_arrow_up_full.svg"
              alt="submit"
              width={24}
              height={24}
              className={styles.submitButtonIcon}
            />
          </IconButton>
        </div>
      </div>
    </div>
  );
}

export default ChatContent;
